export const RP_GAS_COMPOSITION_MODEL_LIST = 'RP_GAS_COMPOSITION_MODEL_LIST'
export const RP_GAS_COMPOSITION_SEARCH = 'RP_GAS_COMPOSITION_SEARCH'
export const RP_GAS_COMPOSITION_PAGINATION = 'RP_GAS_COMPOSITION_PAGINATION'